import { useCallback, useEffect, useState } from 'react'
import { api, session } from './api.js'
import Login from './pages/Login.jsx'
import TableauDeBord from './pages/TableauDeBord.jsx'
import Dossiers from './pages/Dossiers.jsx'
import Dossier from './pages/Dossier.jsx'
import RendezVous from './pages/RendezVous.jsx'
import Envois from './pages/Envois.jsx'
import Bibliotheque from './pages/Bibliotheque.jsx'
import Demarches from './pages/Demarches.jsx'
import Apparence from './pages/Apparence.jsx'
import Circuits from './pages/Circuits.jsx'
import Courriels from './pages/Courriels.jsx'
import Creneaux from './pages/Creneaux.jsx'
import Publication from './pages/Publication.jsx'
import Collectivites from './pages/Collectivites.jsx'
import Parametres from './pages/Parametres.jsx'

const MENU = [
  { g: 'Traitement' },
  { id: 'tableau', label: 'Tableau de bord' },
  { id: 'dossiers', label: 'Dossiers' },
  { id: 'rendezvous', label: 'Rendez-vous' },
  { id: 'envois', label: 'Envois' },
  { g: 'Mon portail' },
  { id: 'bibliotheque', label: 'Ajouter des démarches' },
  { id: 'demarches', label: 'Mes démarches' },
  { id: 'apparence', label: 'Apparence du portail' },
  { g: 'Réglages' },
  { id: 'circuits', label: 'Circuits de traitement' },
  { id: 'courriels', label: 'Courriels types' },
  { id: 'creneaux', label: 'Créneaux de rendez-vous' },
  { id: 'collectivites', label: 'Mes collectivités' },
  { id: 'parametres', label: 'Paramètres' },
]

// Ces écrans modifient des définitions : ils ne s'ouvrent qu'en brouillon.
const EDITION = ['bibliotheque', 'apparence', 'circuits', 'courriels', 'creneaux']

export default function App() {
  const [moi, setMoi] = useState(null)
  const [page, setPage] = useState({ id: 'tableau' })
  const [attente, setAttente] = useState(0)
  const [erreur, setErreur] = useState('')

  const charger = useCallback(async () => {
    try {
      const me = await api.me()
      setMoi(me)
      if (!session.org && me.orgs.length) session.setOrg(me.orgs[0].id)
      const p = await api.publishPreview()
      setAttente(p.changes.length)
    } catch (e) { setErreur(e.message) }
  }, [])

  useEffect(() => { if (session.token) charger() }, [charger])

  if (!session.token) return <Login onLogin={charger} />
  if (!moi) return <p className="chargement">{erreur || 'Chargement…'}</p>

  const org = moi.orgs.find((o) => o.id === session.org) || moi.orgs[0]
  const aller = (id, param) => setPage({ id, param })
  const ouvrirDossier = (id) => setPage({ id: 'dossier', param: id })

  return (
    <>
      <header className="console">
        <span className="marque">UCIVIS</span>
        <select value={org.id} aria-label="Collectivité"
                onChange={(e) => { session.setOrg(e.target.value); window.location.reload() }}>
          {moi.orgs.map((o) => (
            <option key={o.id} value={o.id}>{o.name}{o.kind === 'agglo' ? ' (intercommunalité)' : ''}</option>
          ))}
        </select>
        <div className="env" role="group" aria-label="Environnement">
          <button className={session.env === 'draft' ? 'on' : ''}
                  onClick={() => { session.setEnv('draft'); window.location.reload() }}>Brouillon</button>
          <button className={session.env === 'live' ? 'on' : ''}
                  onClick={() => { session.setEnv('live'); window.location.reload() }}>En ligne</button>
        </div>
        {attente > 0
          ? <button className="btn pri sm" onClick={() => aller('publication')}>
              {attente} changement{attente > 1 ? 's' : ''} à mettre en ligne
            </button>
          : <span className="ok">portail à jour</span>}
        <div className="pousse" />
        <button className="lien" onClick={() => { session.clear(); window.location.reload() }}>Quitter</button>
      </header>

      <div className="app">
        <nav className="rail" aria-label="Sections">
          <div className="titre">{org.name}<span>{org.population.toLocaleString('fr-FR')} habitants</span></div>
          {MENU.map((m, i) => m.g
            ? <p className="groupe" key={i}>{m.g}</p>
            : <button key={m.id} className={page.id === m.id ? 'on' : ''}
                      onClick={() => aller(m.id)}>{m.label}</button>)}
        </nav>

        <main>
          {session.env === 'live' && EDITION.includes(page.id)
            ? <LectureSeule />
            : <>
                {page.id === 'tableau' && <TableauDeBord onOuvrir={ouvrirDossier} onAller={aller} />}
                {page.id === 'dossiers' && <Dossiers onOuvrir={ouvrirDossier} />}
                {page.id === 'dossier' && <Dossier id={page.param} onRetour={() => aller('dossiers')} />}
                {page.id === 'rendezvous' && <RendezVous onOuvrir={ouvrirDossier} />}
                {page.id === 'envois' && <Envois onOuvrir={ouvrirDossier} />}
                {page.id === 'bibliotheque' && <Bibliotheque orgId={org.id} />}
                {page.id === 'demarches' && <Demarches />}
                {page.id === 'apparence' && <Apparence />}
                {page.id === 'circuits' && <Circuits />}
                {page.id === 'courriels' && <Courriels />}
                {page.id === 'creneaux' && <Creneaux />}
                {page.id === 'publication' && <Publication onFini={charger} />}
                {page.id === 'collectivites' && <Collectivites moi={moi} />}
                {page.id === 'parametres' && <Parametres />}
              </>}
        </main>
      </div>
    </>
  )
}

function LectureSeule() {
  return (
    <div className="carte vide">
      <h2>Ici, on regarde sans toucher</h2>
      <p>Cette version est celle que voient les habitants en ce moment. Les modifications se
        préparent dans le brouillon, puis se mettent en ligne quand vous êtes prêt.</p>
      <button className="btn pri" onClick={() => { session.setEnv('draft'); window.location.reload() }}>
        Passer au brouillon
      </button>
    </div>
  )
}
